import { Colors } from '@/components/common';

// Corresponds to table CODE_HRRequestStatus
const requestStatusCodes = {
  new: 1,
  submitted: 2,
  referToCSEEDirectorAnalysis: 3,
  teacherFacilitatorAnalysisProcess: 4,
  returnedToSchool: 5,
  CSEEAnalysisProcess: 6,
  SAEEPendingAnalysis: 7,
  CSEEPendingAnalysis: 8,
  returnedToFacilitatorTeacher: 9,
  SAEEAnalysisProcess: 10,
  returnedToCSEEDirector: 11,
  recomended: 12,
  notRecomended: 13,
  pendingCSEEAnalysis: 14,
  RecommendedExistingResource: 15,
  Cancelada:16,
  PendienteDeAsignar: 17,
  CreateProvisionalRemedyRequest: 18,
  ApprovedProvisionalRemedy: 19,
  NotRecommendedPEIAmendment: 20,
  NotCurrentDischarge: 21
};

const requestStatusString = {
  1: 'Nuevo',
  2: 'Sometido',
  3: 'Referido a Análisis del Director CSEE',
  4: 'Proceso Análisis del Facilitador Docente',
  5: 'Devuelto a la Escuela',
  6: 'Proceso de Análisis de CSEE',
  7: 'Pendiente de Análisis de la SAEE',
  8: 'Pendiente de Análisis del Director CSEE',
  9: 'Devuelto al Facilitador Docente',
  10: 'Proceso de Análisis de la SAEE',
  11: 'Devuelto al Director CSEE',
  12: 'Recomendado',
  13: 'No Recomendado',
  14: 'Pendiente de Análisis de CSEE',
  15: 'Recomendado - Recurso Existente',
};

const getRequestStatusColor = (statusId, isHexColor) => {
  switch (statusId) {
    case requestStatusCodes.new:
      return isHexColor ? '#b5c3bc' : Colors.GRAY;
    case requestStatusCodes.submitted:
    case requestStatusCodes.teacherFacilitatorAnalysisProcess:
    case requestStatusCodes.SAEEAnalysisProcess:
    case requestStatusCodes.CSEEAnalysisProcess:
      return isHexColor ? '#f8ea80' : Colors.YELLOW;
    case requestStatusCodes.returnedToFacilitatorTeacher:
    case requestStatusCodes.returnedToSchool:
    case requestStatusCodes.returnedToCSEEDirector:
      return isHexColor ? '#fcc9c8' : Colors.PINK;
    case requestStatusCodes.CSEEPendingAnalysis:
    case requestStatusCodes.SAEEPendingAnalysis:
    case requestStatusCodes.pendingCSEEAnalysis:
      return isHexColor ? '#ddb3d7' : Colors.VIOLET;
    case requestStatusCodes.recomended:
    case requestStatusCodes.RecommendedExistingResource:
      return isHexColor ? '#a3e5b3' : Colors.GREEN_LIGHT;
    case requestStatusCodes.notRecomended:
      case requestStatusCodes.Cancelada:
      return isHexColor ? '#d5b899' : Colors.BROWN;
    default:
      return isHexColor ? '#b5c3bc' : Colors.GRAY;
  }
};

export { requestStatusCodes, requestStatusString, getRequestStatusColor };
